/**
 * Action type to signal the closing of the participants pane.
 */
export const PARTICIPANTS_PANE_CLOSE = 'PARTICIPANTS_PANE_CLOSE';
/**
 * Action type to signal the opening of the participants pane.
 */
export const PARTICIPANTS_PANE_OPEN = 'PARTICIPANTS_PANE_OPEN';
/**
 * Action type to set the volume of the participant.
 */
export const SET_VOLUME = 'SET_VOLUME';
export const CHANGE_TAB_PARTICIPANT = 'CHANGE_TAB_PARTICIPANT';
export const CHANGE_DISPLAY_LOBBY = 'CHANGE_DISPLAY_LOBBY';
export const CHANGE_DISPLAY_PARTICIPANE = 'CHANGE_DISPLAY_PARTICIPANE';
export const CHANGE_DISPLAY_RAISED_HAND = 'CHANGE_DISPLAY_RAISED_HAND';
export const DATA_ATTENDANCE = 'DATA_ATTENDANCE';
export const CHANGE_DISPLAY_ONLINE = 'CHANGE_DISPLAY_ONLINE';
export const CHANGE_DISPLAY_OFFLINE = 'CHANGE_DISPLAY_OFFLINE';
